import React from "react";
import { useQuery } from "@apollo/client";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { frequencyType, sampleType } from "../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import { GET_PUBLIC_ROUTINE_BACTERIOLOGICAL_SAMPLING_REQUIREMENT } from "../../../queries/archiveQrys/bacterialSummaryQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const PublicRoutineBacteriologicalSamplingRequirementTable = (props) => {
  const { systemId } = props;

  const columns = [
    /* {
      Header: () => null,
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <FontAwesomeIcon className='font-icon' icon={faCaretDown} cypressid={row.original.facilityId + "_facd"} />
          ) : (
            <FontAwesomeIcon className='font-icon' icon={faCaretRight} cypressid={row.original.sourceId + "_facr"} />
          )}
        </span>
      )
    },*/
    {
      Header: "Sample Required",
      accessor: (d) => {
        return d.sampleCount + "/" + frequencyType[d.sampleFrequency] + "/" + sampleType[d.sampleType];
      },
      width: 120
    },
    {
      Header: "Schedule Begin",
      accessor: (d) => {
        return d.scheduleBeginDate ? convertTimeStampToDate(d.scheduleBeginDate) : "";
      },
      width: 120
    },
    {
      Header: "Schedule End",
      accessor: (d) => {
        return d.scheduleEndDate ? convertTimeStampToDate(d.scheduleEndDate) : "";
      },
      width: 120
    },
    {
      Header: "Operation Begin",
      accessor: (d) => {
        return d.operatorStartMonth + "/" + d.operatorStartDay;
      },
      width: 120
    },
    {
      Header: "Operation End",
      accessor: (d) => {
        return d.operatorEndMonth + "/" + d.operatorEndDay;
      },
      width: 120
    },
    {
      Header: "Facility",
      accessor: (d) => {
        return d.facilityCodeString ? d.facilityCodeString : "";
      },
      width: 70
    }
  ];

  /*const details = React.useMemo(
    () => [
      {
        Header: "Facility Name",
        accessor: "facilityName",
        width: 150
      },
      {
        Header: "Last Sample Date",
        accessor: (d) => {
          return d.lastSampleDate ? convertTimeStampToDate(d.lastSampleDate) : "";
        },
        width: 100
      },
      {
        Header: "Next Sample Due",
        accessor: "nextSampleDue",
        width: 100
      }
    ],
    []
  );*/

  const { loading, error, data } = useQuery(GET_PUBLIC_ROUTINE_BACTERIOLOGICAL_SAMPLING_REQUIREMENT, {
    variables: { systemId }
  });

  /*const subTable = React.useCallback(
    ({ row }) =>
      row.original.facilityDetail !== null ? (
        <DtsReactTable columns={details} data={row.original.facilityDetail} headerColor='grey' />
      ) : (
        ""
      ),
    [details]
  );*/

  /*const expandedRows = React.useMemo(() => {
    if (data) {
      let arr = {};
      let d = data;
      if (d.getPublicRoutineBacteriologicalSamplingRequirement.length > 0) {
        d.getPublicRoutineBacteriologicalSamplingRequirement.forEach(function (elem, index) {
          if (elem.facilityDetail !== null ) {
            if(elem.facilityDetail.length > 0){
              arr[index] = true;
            }
          }
        });
      }
      return arr;
    }
  }, [data]);*/

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getPublicRoutineBacteriologicalSamplingRequirement.length > 0 ? (
        <DtsReactTable
          data={data.getPublicRoutineBacteriologicalSamplingRequirement}
          columns={columns}
          headerColor='ddw'
          cypressid='routineBactiSampling'
          //renderRowSubComponent={subTable}
          //expandRows={true}
          //expandedRowObj={expandedRows}
          //subTableId={"_rbSubTable"}
        />
      ) : (
        <span>No public bacteriological sampling requirements were found in the database.</span>
      )}
    </>
  );
};

export default PublicRoutineBacteriologicalSamplingRequirementTable;
